import React from 'react';
import FormTemplate from './v2/components/FormTemplate';

export default function PatientInformationSubclinicalForm() {
    return (
        <FormTemplate formTitle="Your Information" />
    );
}